import LunchMeal from "./vue/web/components/LunchMeal";

require('./sentry');
require('./bootstrap');
require('../node_modules/slick/slick');

$(document).ready(function () {

    require('./web/bulma');
    require('./web/layout');
    require('./web/lunch-menu');
    require('./web/offer-links');

});

import store from './store/web';
import Vue from "vue";

import VueInternationalization from 'vue-i18n';
import Locale from './vue-i18n-locales.generated';
import OfferMeal from "./vue/web/components/OfferMeal";
import OrderSocket from "./vue/web/components/OrderSocket";
import OrderState from "./vue/web/components/OrderState";
import OrderNote from "./vue/web/components/order/OrderNote";
import CartInfo from "./vue/web/components/CartInfo";
import CartRecapitulation from "./vue/web/components/CartRecapitulation";
import ReservationForm from "./vue/web/forms/ReservationForm";
import EventReservationForm from "./vue/web/forms/EventReservationForm";
import GiftCouponForm from "./vue/web/forms/GiftCouponForm";
import CartButton from "./vue/web/components/CartButton";
import Cart from "./vue/web/components/Cart";
import OfferMealModal from "./vue/web/modals/OfferMealModal";
import CookiesModal from "./vue/web/modals/CookiesModal";
import CookiesInit from "./vue/web/inits/CookiesInit";
import CookiesToolbar from "./vue/web/components/CookiesToolbar";

const lang = document.documentElement.lang.substr(0, 2);
Vue.use(VueInternationalization);
const i18n = new VueInternationalization({
    locale: lang,
    messages: Locale
});

VueInternationalization.prototype.getChoiceIndex = function (choice) {
    switch (this.locale) {
        case 'cs':
        case 'sk':
            if (choice < 2) return choice;
            if (choice < 5) return 2;
            return 3;
        default:
            if (choice < 2) return choice;
            return 2;
    }
};

window.Vue = Vue;

Vue.component('reservationform', ReservationForm);
Vue.component('eventreservationform', EventReservationForm);
Vue.component('giftcouponform', GiftCouponForm);
Vue.component('cart', Cart);
Vue.component('cartbutton', CartButton);
Vue.component('offermeal', OfferMeal);
Vue.component('ordersocket', OrderSocket);
Vue.component('orderstate', OrderState);
Vue.component('cartinfo', CartInfo);
Vue.component('cartrecapitulation', CartRecapitulation);
Vue.component('ordernote', OrderNote);
Vue.component('lunchmeal', LunchMeal);
Vue.component('offermealmodal', OfferMealModal);
Vue.component('cookiesmodal', CookiesModal);
Vue.component('cookiesinit', CookiesInit);
Vue.component('cookiestoolbar', CookiesToolbar);

import Checkbox from 'buefy/src/components/checkbox'
import Switch from 'buefy/src/components/switch'

Vue.use(Checkbox);
Vue.use(Switch);

const app = new Vue({
    el: '#app',
    i18n,
    store,
});
